import api from "./api";

// Base de Conhecimento (artigos da TI por categoria).
const knowledgeService = {
  list: ({ q, category, status } = {}) =>
    api.get("/knowledge/", { params: { q, category, status_filter: status } }).then((r) => r.data),
  get: (id) => api.get(`/knowledge/${id}`).then((r) => r.data),
  create: (data) => api.post("/knowledge/", data).then((r) => r.data),
  update: (id, data) => api.put(`/knowledge/${id}`, data).then((r) => r.data),
  remove: (id) => api.delete(`/knowledge/${id}`),
  suggest: (ticketId) => api.get("/knowledge/suggest", { params: { ticket_id: ticketId } }).then((r) => r.data),
  related: (id) => api.get(`/knowledge/${id}/related`).then((r) => r.data),
  helpful: (id, vote) => api.post(`/knowledge/${id}/helpful`, null, { params: { vote } }).then((r) => r.data),
  // Base pública (sem login).
  listPublic: ({ q, category } = {}) => api.get("/knowledge/public", { params: { q, category } }).then((r) => r.data),
  getPublic: (id) => api.get(`/knowledge/public/${id}`).then((r) => r.data),
};

export default knowledgeService;
